import { render, staticRenderFns } from "./location-modal-send-message.vue?vue&type=template&id=6ea895b4&scoped=true"
import script from "./location-modal-send-message.vue?vue&type=script&lang=js"
export * from "./location-modal-send-message.vue?vue&type=script&lang=js"
import style0 from "./location-modal-send-message.vue?vue&type=style&index=0&id=6ea895b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea895b4",
  null
  
)

export default component.exports